import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  COMPANIES_REFRESH: createSagaAction('COMPANIES_REFRESH'),
  CREATE_NEW_COMPANY: createSagaAction('CREATE_NEW_COMPANY'),
  UPDATE_SAVED_COMPANY: createSagaAction('UPDATE_SAVED_COMPANY'),
  DELETE_COMPANY: createSagaAction('DELETE_COMPANY'),
  GET_COMPANIES: createSagaAction('GET_COMPANIES'),
  GET_COMPANIES_VENDOR_CLIENTS: createSagaAction('GET_COMPANIES_VENDOR_CLIENTS'),

  GET_COMPANY_LEADS: createSagaAction('GET_COMPANY_LEADS'),
  GET_COMPANY_JOBS: createSagaAction('GET_COMPANY_JOBS'),

  UPLOAD_COMPANY_ATTACHMENT: createSagaAction('UPLOAD_COMPANY_ATTACHMENT'),
  GET_COMPANY_ATTACHMENTS: createSagaAction('GET_COMPANY_ATTACHMENTS'),
  UPDATE_COMPANY_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_COMPANY_ATTACHMENT_DESCRIPTION'),
  DELETE_COMPANY_ATTACHMENT: createSagaAction('DELETE_COMPANY_ATTACHMENT'),

  // notes
  GET_COMPANY_NOTE: createSagaAction('GET_COMPANY_NOTE'),
  CREATE_COMPANY_NOTE: createSagaAction('CREATE_COMPANY_NOTE'),
  EDIT_COMPANY_NOTE: createSagaAction('EDIT_COMPANY_NOTE'),
  DELETE_COMPANY_NOTE: createSagaAction('DELETE_COMPANY_NOTE')
}

// Action Creators
export const actions = {
  companiesRefresh: () => ({ type: constants.COMPANIES_REFRESH.ACTION }),
  createNewCompany: ({ company, userId }) => ({
    type: constants.CREATE_NEW_COMPANY.ACTION,
    company,
    userId
  }),
  updateSavedCompany: ({ company, companyId, userId }) => ({
    type: constants.UPDATE_SAVED_COMPANY.ACTION,
    company,
    companyId,
    userId
  }),
  deleteCompany: ({ companyId }) => ({
    type: constants.DELETE_COMPANY.ACTION,
    companyId
  }),
  getAllCompanies: next => ({ type: constants.GET_COMPANIES.ACTION, next }),
  getAllCompaniesVendorsClients: () => ({ type: constants.GET_COMPANIES_VENDOR_CLIENTS.ACTION }),
  getCompanyLeads: ({ companyId }) => ({ type: constants.GET_COMPANY_LEADS.ACTION, companyId }),
  getCompanyJobs: ({ companyId }) => ({ type: constants.GET_COMPANY_JOBS.ACTION, companyId }),
  // Attachment actions
  uploadAttachment: ({ formData, companyId }) => ({
    type: constants.UPLOAD_COMPANY_ATTACHMENT.ACTION,
    formData,
    companyId
  }),

  getAttachments: ({ companyId }) => ({
    type: constants.GET_COMPANY_ATTACHMENTS.ACTION,
    companyId
  }),

  updateAttachmentDescription: ({ attachmentId, currentId, description, userId }) => ({
    type: constants.UPDATE_COMPANY_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    currentId,
    description,
    userId
  }),

  deleteAttachment: ({ attachmentId, currentId }) => ({
    type: constants.DELETE_COMPANY_ATTACHMENT.ACTION,
    attachmentId,
    currentId
  }),
  // notes
  getCompanyNote: ({ companyId }) => ({
    type: constants.GET_COMPANY_NOTE.ACTION,
    companyId
  }),
  createCompanyNote: ({ content, userId, companyId }) => ({
    type: constants.CREATE_COMPANY_NOTE.ACTION,
    content,
    userId,
    companyId
  }),
  editCompanyNote: ({ content, noteId, companyId }) => ({
    type: constants.EDIT_COMPANY_NOTE.ACTION,
    content,
    noteId,
    companyId
  }),
  deleteCompanyNote: ({ noteId, companyId }) => ({
    type: constants.DELETE_COMPANY_NOTE.ACTION,
    noteId,
    companyId
  })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(
  initialState,
  (state, { type, payload, companyLeads, companyJobs, companyNotes }) => {
    switch (type) {
      default:
        return state
      case constants.COMPANIES_REFRESH.SUCCESS:
        return { ...state, payload }
      case constants.GET_COMPANIES.SUCCESS:
        return { ...state, payload }
      case constants.GET_COMPANIES_VENDOR_CLIENTS.SUCCESS:
        return { ...state, payload }
      case constants.CREATE_NEW_COMPANY.SUCCESS:
        return { ...state }
      case constants.UPDATE_SAVED_COMPANY.SUCCESS:
        return { ...state }
      case constants.DELETE_COMPANY.SUCCESS:
        return { ...state }

      case constants.GET_COMPANY_LEADS.SUCCESS:
        return { ...state, companyLeads: companyLeads }

      case constants.GET_COMPANY_JOBS.SUCCESS:
        return { ...state, companyJobs: companyJobs }

      // attachments
      case constants.UPLOAD_COMPANY_ATTACHMENT.ACTION:
        return { ...state, error: null, uploadingAttachment: true }
      case constants.UPLOAD_COMPANY_ATTACHMENT.SUCCESS:
        return {
          ...state,
          uploadingAttachment: false
        }

      case constants.GET_COMPANY_ATTACHMENTS.ACTION:
        return { ...state, error: null, loadingAttachments: true }
      case constants.GET_COMPANY_ATTACHMENTS.SUCCESS:
        return {
          ...state,
          companyAttachments: payload,
          loadingAttachments: false
        }

      case constants.UPDATE_COMPANY_ATTACHMENT_DESCRIPTION.SUCCESS:
        return {
          ...state
        }

      case constants.DELETE_COMPANY_ATTACHMENT.ACTION:
        return { ...state, error: null, deletingAttachment: true }
      case constants.DELETE_COMPANY_ATTACHMENT.SUCCESS:
        return {
          ...state,
          deletingAttachment: false
        }
      // NOTES
      case constants.GET_COMPANY_NOTE.SUCCESS:
        return { ...state, companyNotes: companyNotes }

      case constants.CREATE_COMPANY_NOTE.ACTION:
        return { ...state }
      case constants.CREATE_COMPANY_NOTE.SUCCESS:
        return {
          ...state
        }
      case constants.EDIT_COMPANY_NOTE.ACTION:
        return { ...state }
      case constants.EDIT_COMPANY_NOTE.SUCCESS:
        return {
          ...state
        }
      case constants.DELETE_COMPANY_NOTE.ACTION:
        return { ...state }
      case constants.DELETE_COMPANY_NOTE.SUCCESS:
        return {
          ...state
        }
    }
  }
)



// WEBPACK FOOTER //
// ./src/redux/modules/companiesActions.js